module.exports = __webpack_public_path__ + "static/media/halo2.ce3d8414.svg";